import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, of } from 'rxjs';
import {
    ActionType,
    JobRecommendationCategoriesActions
} from 'src/app/accountmanagers/details/flyouts/recommendations-flyout/models/job-recommendation-categories-actions.model';
import { JobRecommendationsService } from 'src/app/accountmanagers/details/flyouts/recommendations-flyout/job-recommendations-service';
import * as JobRecommendationActions from 'src/app/root-store/account-managers-store/actions/job-recommendations.actions';
import { HttpResponseHelpers } from 'src/app/shared/helpers';

@Injectable()
export class JobRecommendationEffects {
    loadJobRecommendations$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(JobRecommendationActions.loadJobRecommendations),
            switchMap((action) => {
                return this._jobRecommendationsService.loadRecommendations(action.jobId).pipe(
                    switchMap((data: JobRecommendationCategoriesActions[]) => {
                        return of(
                            JobRecommendationActions.loadJobRecommendationsSuccess({
                                recommendations: data,
                                numTodos: data.filter(
                                    (f) => f.actionType === ActionType.Todo && (f.recommendAction || f.isCustomAction)
                                ).length,
                                numCompleted: data.filter((f) => f.actionType === ActionType.Completed).length,
                                numDismissed: data.filter((f) => f.actionType === ActionType.Dismissed).length
                            })
                        );
                    }),
                    catchError((error: unknown) =>
                        of(
                            JobRecommendationActions.loadJobRecommendationsFailure({
                                error: HttpResponseHelpers.parseErrorResponse(error)
                            })
                        )
                    )
                );
            })
        );
    });

    updateRecommendation$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(JobRecommendationActions.updateRecommendation),
            switchMap((action) =>
                this._jobRecommendationsService.updateRecommendation(action.recommendation).pipe(
                    map((result) => JobRecommendationActions.updateRecommendationSuccess({ recommendation: result })),
                    catchError((error: unknown) =>
                        of(
                            JobRecommendationActions.updateRecommendationFailure({
                                error: HttpResponseHelpers.parseErrorResponse(error)
                            })
                        )
                    )
                )
            )
        );
    });

    constructor(
        private readonly _actions$: Actions,
        private readonly _jobRecommendationsService: JobRecommendationsService
    ) {}
}
